<div #container class="osp-toast__container" [class]="cssClass" [ngClass]="getPositionClass()">
  @for (message of toastMessages; track message.id) {
    <div
      [attr.id]="message.id ?? null"
      [class]="message.styleClass ?? ''"
      [ngClass]="['osp-toast__message', 'osp-toast__message--' + getSeverity(message)]"
      [@messageState]="messageAnimationState"
      (@messageState.start)="onMessageAnimationStart($event)"
      (@messageState.done)="onMessageAnimationDone($event)"
      (mouseenter)="onMessageMouseEnter(message)"
      (mouseleave)="onMessageMouseLeave(message)"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      @if (template) {
        <ng-container
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ $implicit: message, closeFn: getCloseFunction(message) }"
        ></ng-container>
      } @else {
        <div class="osp-toast__content" [class]="message.contentStyleClass ?? ''">
          @if (message.icon) {
            <span [class]="'osp-toast__icon ' + message.icon"></span>
          } @else {
            <span class="osp-toast__icon" [ngClass]="getDefaultIcon(message)" [attr.aria-hidden]="true"></span>
          }
          <div class="osp-toast__text">
            <div class="osp-toast__summary">{{ message.summary }}</div>
            <div class="osp-toast__detail">{{ message.detail }}</div>
          </div>
          @if (message.closable !== false) {
            <button
              type="button"
              class="osp-toast__close"
              [attr.aria-label]="closeAriaLabel"
              (click)="onCloseIconClick($event, message)"
              (keydown.enter)="onCloseIconClick($event, message)"
            >
              @if (message.closeIcon) {
                <span [class]="'osp-toast__close-icon ' + message.closeIcon"></span>
              } @else {
                <span class="osp-toast__close-icon" [ngClass]="defaultCloseIcon" [attr.aria-hidden]="true"></span>
              }
            </button>
          }
        </div>
      }
      @if (message.sticky) {
        <div class="osp-toast__lifebar" [ngClass]="'osp-toast__lifebar--' + getSeverity(message)"></div>
      } @else {
        <div
          class="osp-toast__lifebar"
          [ngClass]="'osp-toast__lifebar--' + getSeverity(message)"
          @lifebarState
          [ngStyle]="{ transition: getLifebarTransition(message) }"
        ></div>
      }
    </div>
  }
</div>
